<template>
  <MainTemplate>
    <div class="setting-parent container">
      <div class="setting-header">
        <el-row>
          <el-col :span="4">&nbsp;</el-col>
          <el-col :span="18">
            <el-breadcrumb separator=">">
              <el-breadcrumb-item >
                <strong>{{ $t('setting') }}</strong>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
        </el-row>
      </div>
      <router-view></router-view>
    </div>
  </MainTemplate>
</template>

<script>
import MainTemplate from '@/templates/MainTemplate.vue'
import i18nMessages from '@/translations/Setting/Index.i18n'

export default {
  name: 'Setting',
  components: { MainTemplate },
  i18n: { messages: i18nMessages },
  methods: { }
}
</script>

<style scoped>
  .setting-header {
    background: #ececec;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 10px;
    border-bottom-color: #cccccc;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }
  .setting-header > span {
    color: #bbb;
  }
  .setting-parent {
    padding: 0px 0px;
  }
  .el-breadcrumb {
    font-size: 1.5em;
    font-weight: bold;
    margin: 0;
  }
</style>
